import React, { Component } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    container: {
        color: "red"
    }
}))

export const Error = ({ children, ...props }) => {

    const classes = useStyles()
    return (
        <div className={classes.container}>{children}</div>
    )

}
